import React, {Component} from 'react';
import {loadModules} from 'esri-loader';
import {convertHex2Array} from "../../../utils";
import {getServiceIntensityPolygonReal, getServiceIntensityPolygonAssigned} from "../layers/utils";
import i18n from 'i18next';

let areasAndLengthParams = null;

export default class PolygonDraw extends Component {

    constructor(props) {
        super(props);
        this.state = {
            draw: null,
            sketchViewModel: null,
            measureWidget: null,
            editMode: false
        };
        this.needToClear = false;
        this.action = null;
    }

    componentDidMount() {
        loadModules([
            "esri/tasks/support/AreasAndLengthsParameters"
        ]).then(([AreasAndLengthsParameters]) => {
            areasAndLengthParams = new AreasAndLengthsParameters({
                areaUnit: "square-meters",
                lengthUnit: "meters",
                calculationType: 'geodesic',
                polygons: []
            });
        });

        loadModules(['esri/views/draw/Draw', 'esri/widgets/Sketch/SketchViewModel']).then(([Draw, SketchViewModel]) => {
            if(this.props.sizes) {
                let measureWidget = document.getElementById('measure-widget-value');
                if(!measureWidget){
                    measureWidget = document.createElement('div');
                    measureWidget.innerHTML = '<span id="measure-widget-value">-</span> m<sup>2</sup>';
                    measureWidget.className = 'esri-widget';
                    measureWidget.id = 'measure-widget';
                    measureWidget.style = 'padding: 8px 5px 5px 5px; min-width: 32px; min-height: 32px';
                    this.props.view.ui.add(measureWidget, "bottom-left");

                    this.setState({measureWidget})
                }
            }

            this.props.view.ui.remove("polygon-button");
            this.props.view.ui.add("polygon-button", 'bottom-left');

            if(!this.props.readOnly){
                const draw = new Draw({
                    view: this.props.view
                });

                // create a new sketch view model
                const sketchViewModel = new SketchViewModel({
                    view: this.props.view,
                    layer: this.props.map.findLayerById(this.props.layerId),
                    multipleSelectionEnabled: true
                });

                this.setState({
                    draw,
                    sketchViewModel
                });

                sketchViewModel.on(['create', 'update'], this.updateGraphic);
            }

            if (this.props.polygon) {
                this.createPolygon({vertices: this.props.polygon.polygon})
            }

        }).catch((err) => console.error(err));
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (this.props.color !== nextProps.color) {
            if (nextProps.polygon) {
                this.props.view.graphics.removeAll();
                this.createPolygon({vertices: nextProps.polygon.polygon})
            }
        }
    }

    componentWillUnmount() {
        this.props.view.ui.remove("polygon-button");
        this.props.view.graphics.removeAll();
        this.props.view.ui.remove(this.state.draw);
        this.props.view.ui.remove(this.state.sketchViewModel);
        if(this.state.measureWidget) {
            this.props.view.ui.remove(this.state.measureWidget);
        }
    }

    handleCreate = () => {
        if(!this.state.editMode){
            this.needToClear = true;
            // creates and returns an instance of PolyLineDrawAction
            this.action = this.state.draw.create("polygon");
            // focus the view to activate keyboard shortcuts for sketching
            this.props.view.focus();
            //Initialize cursor-update only after first vertex added. Prevent remove previous polygon on cursor-update
            this.action.on(['vertex-add', 'vertex-remove', 'draw-complete'], this.createPolygon);

            this.setState({editMode: true});
        } else{
            this.action._clickEnabled = false;
            this.action._dragEnabled = false;
            this.needToClear = false;

            this.setState({editMode: false});
        }
    };

    setValueToAreaWidget(value) {
        let measureWidget = document.getElementById('measure-widget-value');
        if(measureWidget){
            measureWidget.innerText = value;
        }
    }

    createPolygon = (event) => {
        loadModules([
            'esri/Graphic',
            'esri/tasks/GeometryService',
            "esri/tasks/support/AreasAndLengthsParameters"
        ]).then(([Graphic, GeometryService, AreasAndLengthsParameters]) => {

            this.props.map.findLayerById(this.props.layerId).graphics.removeAll();

            const object = this.props.object;
            let color = this.props.color;
            let graphicAssigned = null;

            const polygon = {
                type: 'polygon', // autocasts as new Polygon()
                rings: event.vertices,
                spatialReference: this.props.view.spatialReference
            };

            //Add intensity additional object
            if(object && object.type && object.type.useServiceIntensityColors){
                graphicAssigned = new Graphic({
                    geometry: polygon,
                    symbol: getServiceIntensityPolygonAssigned(object.intensityAssigned, object.type)
                });
                this.props.map.findLayerById(this.props.layerId).graphics.add(graphicAssigned);
            }

            // Change color of polygon
            if (color){
                color = convertHex2Array(color, 0.7);
            }
            let fillSymbol = {
                type: "simple-fill",
                color: color ? color : [247, 132, 12, 0.8],
                style: "solid",
                outline: {
                    color: 'red',
                    width: 1
                }
            };

            if(object && object.type && object.type.useServiceIntensityColors){
                fillSymbol = getServiceIntensityPolygonReal(object.intensityReal, object.type);
            }

            const graphic = new Graphic({
                geometry: polygon,
                symbol: fillSymbol
            });

            this.props.map.findLayerById(this.props.layerId).graphics.add(graphic);

            if(this.props.sizes && (event.type === undefined || event.type === 'draw-complete')){
                // http://tar-test.tallinnlv.ee/arcgis/rest/services/Utilities/Geometry/GeometryServer
                let gs = new GeometryService({url: this.props.geometryServerURL});
                areasAndLengthParams.polygons = [graphic.geometry];

                gs.areasAndLengths(areasAndLengthParams).then((results) =>{
                    this.setValueToAreaWidget(Math.round(results.areas[0]*100)/100);
                    this.props.sizes(results);
                });
            }

            if (event.type === 'vertex-add') {
                if(this.needToClear){
                    this.props.view.graphics.removeAll();
                    this.setValueToAreaWidget('-');
                    this.needToClear = false;
                }

                //Add previously not added cursor-update
                this.action.on(['cursor-update'], this.createPolygon);
            }

            if (event.type === 'draw-complete') {
                this.props.update({
                    type: graphic.geometry.type,
                    coordinates: graphic.geometry.rings,
                });

                this.setState({editMode: false});
            }

        }).catch((err) => console.error(err));
    };

    updateGraphic = (event) => {
        if(event.state === 'complete'){
            loadModules([
                'esri/tasks/GeometryService',
                "esri/tasks/support/AreasAndLengthsParameters"
            ]).then(([GeometryService, AreasAndLengthsParameters]) => {
                let gs = new GeometryService({url: this.props.geometryServerURL});
                areasAndLengthParams.polygons = [event.graphics[0].geometry];

                gs.areasAndLengths(areasAndLengthParams).then((results) => {
                    this.setValueToAreaWidget(Math.round(results.areas[0] * 100) / 100);
                    this.props.sizes(results);
                });
            });
        }

        if (event.state === 'cancel' || event.state === 'complete') {
            this.props.update({
                type: event.graphics[0].geometry.type,
                coordinates: event.graphics[0].geometry.rings,
            });
        }
    };

    render() {
        return (
            <div>
                <div
                    id="polygon-button"
                    onClick={this.handleCreate}
                    style={{backgroundColor: this.state.editMode && '#f1c71a'}}
                    className={
                        (this.props.readOnly ? "d-none " : "")
                        + ("esri-widget esri-widget--button esri-interactive ")
                    }
                    title={i18n.t('common:map.addPolygon')}
                >
                    <span className="esri-icon-polygon"/>
                </div>
            </div>
        )
    }


}

PolygonDraw.defaultProps = {
  geometryServerURL: 'http://sampleserver6.arcgisonline.com/arcgis/rest/services/Utilities/Geometry/GeometryServer'
};